import {Geolocate} from "../../../models/operations/Geolocate";
import {ProcessStep} from "../../../models/ProcessStep";
import {Unknown} from "../../../models/elements/Unknown";
import {AElement} from "../../../models/elements/AElement";
import StepsAccordingToSpecificationsService from "../StepsAccordingToSpecificationsService";
import {EElementType} from "../../../models/utils/EElementType";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class GeolocationSteps  {

    public getGeolocationSteps(operation: Geolocate, setOperation: (operation: Geolocate) => void) : ProcessStep[] {
        let steps: ProcessStep[] = [];
        steps = steps.concat(this.getEquipmentIdentificationStep(operation, setOperation));
        return steps;
    }

    private getEquipmentIdentificationStep(operation: Geolocate, setOperation: (operation: Geolocate) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const equipment = new Unknown(operation.equipmentId !== undefined ? operation.equipmentId : '');
        const setElement = (element: AElement) => {
            operation.equipmentId = element.serialNumber;
            setOperation(operation);
        }
        steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(EElementType.Unknown, setElement, equipment));
        return steps;
    }

}

export default new GeolocationSteps();
